import { cn } from "../../../helpers/utils";

const elementMap = {
  default: "span",
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  body: "p",
  bold: "span",
  semibold: "span",
  small: "span",
  caption: "span",
  overline: "span",
  link: "a",
  label: "label",
  underline: "span",
};

const variants = {
  default: "text-md font-league",
  h1: "text-3xl font-league-bold",
  h2: "text-2xl font-league-bold",
  h3: "text-xl font-league-bold",
  h4: "text-lg font-league-semibold",
  h5: "text-md font-league-semibold",
  h6: "text-sm font-league-semibold",
  body: "text-md font-league-medium",
  bold: "text-md font-league-bold",
  semibold: "text-md font-league-semibold",
  small: "text-sm font-league-medium",
  caption: "text-xs font-league-light",
  peak: "text-xs font-league-medium",
  overline: "text-xs uppercase tracking-widest",
  link: "text-md font-league-medium underline text-vestelColor hover:text-vestelHoverColor cursor-pointer",
  underline:
    "text-md font-league-medium underline text-vestelColor hover:text-vestelHoverColor cursor-pointer",
  label: "text-sm font-league-semibold text-gray-700",
};

const Typography = ({ variant = "default", children, className }) => {
  const Tag = elementMap[variant] || "span";

  return (
    <Tag className={cn(`${variants[variant]} text-[#2A3133]`, className)}>
      {children}
    </Tag>
  );
};

export default Typography;
